import { render, staticRenderFns } from "./DeleteResourceOwner.vue?vue&type=template&id=15262957&"
import script from "./DeleteResourceOwner.vue?vue&type=script&lang=js&"
export * from "./DeleteResourceOwner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports